import React, { Component } from "react";
import styles from "styles";
import { Link } from "react-router";
import { TableRow, TableRowColumn } from "material-ui/Table";
import RaisedButton from "material-ui/RaisedButton";
import { addNotification } from "actions/notifications/notifications";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";


export class IntegratorRow extends Component {
  constructor(props) {
    super(props);

    this.copyToClipboard = this.copyToClipboard.bind(this);
  }
  copyToClipboard() {
    const {
      item: { token },
      addNotification,
    } = this.props;
    if (!navigator.clipboard) {
      const textArea = document.createElement("textarea");
      textArea.value = token;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        addNotification({
          title: "Success copy",
          message: "Token has been copied to clipboard!",
          level: "success",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3,
        })
      } catch (err) {
        addNotification({
          title: "Error",
          message: "Error copying token!" + err,
          level: "error",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3,
        })
      }

      document.body.removeChild(textArea);
      return;
    }
    navigator.clipboard
      .writeText(token)
      .then(() =>
        addNotification({
          title: "Success copy",
          message: "Token has been copied to clipboard!",
          level: "success",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3,
        })
      )
      .catch((err) =>
        addNotification({
          title: "Error",
          message: "Error copying token!" + err,
          level: "error",
          _id: new Date().getMilliseconds(),
          autoDismiss: 3,
        })
      );
  }
  render() {
    const {
      item: { name = "-", email = "-", token = "-", apiList = [], _id },
    } = this.props;
    const { copyToClipboard } = this;
    return (
      <TableRow>
        <TableRowColumn style={styles.tableRowBordered}>
          <Link to={`/integrators/companies/${_id}`}>{name}</Link>
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>{email}</TableRowColumn>
        {/* TODO: Add Active/Disabled company state in future releases */}
        {/* <TableRowColumn style={styles.tableRowBordered}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <RaisedButton
              buttonStyle={styles.greenBtn}
              labelStyle={{ color: "#fff" }}
              label="Active"
            ></RaisedButton>
            <RaisedButton label="Disabled"></RaisedButton>
          </div>
        </TableRowColumn> */}
        <TableRowColumn style={styles.tableRowBordered}>
          {apiList.map((api, i) => (
            <p key={api.name}>{`${i + 1}. API ${api.name}`}</p>
          ))}
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          {apiList.map((api) => (
            <p key={api.name}>{api.used}</p>
          ))}
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          <div style={styles.fullHeightFlexContainer}>
            <RaisedButton
              style={{ alignSelf: "flex-end" }}
              label="COPY"
              onClick={copyToClipboard}
              primary
            ></RaisedButton>
          </div>
        </TableRowColumn>
        <TableRowColumn style={styles.tableRowBordered}>
          <div style={styles.fullHeightFlexContainer}>
            <p>{_id}</p>
          </div>
        </TableRowColumn>
      </TableRow>
    );
  }
}

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      addNotification,
    },
    dispatch
  )
)(IntegratorRow);



// WEBPACK FOOTER //
// ./app/components/Integrators/List/IntegratorRow.jsx